var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "employee" }, [
    _c(
      "div",
      { staticClass: "employee__inner" },
      [
        _vm.employee.imageForVue.src || _vm.employee.imageForVue.hasCrop
          ? _c("ResponsiveImage", {
              attrs: {
                imageModel: _vm.employee.imageForVue,
                wrapClass: "employee__image",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.employee.imageForVue && !_vm.employee.imageForVue
          ? _c("div", { staticClass: "employee__image" }, [
              _c("img", {
                staticClass: "employee__image--placeholder lazyload",
                attrs: {
                  width: "278",
                  height: "330",
                  src: "/assets/images/placeholders/placeholder_employee.png",
                  alt: "",
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.employee.imageForVue && _vm.employee.imageUrl
          ? _c("div", { staticClass: "employee__image" }, [
              _c("img", {
                staticClass: "employee__image lazyload",
                attrs: { src: `${_vm.employee.imageUrl}?width=278`, alt: "" },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "employee__info" }, [
          _c("div", { staticClass: "employee__row" }, [
            _c("h3", { staticClass: "employee__name" }, [
              _vm._v(_vm._s(_vm.employee.name)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "employee__row" }, [
            _c("p", { staticClass: "employee__title" }, [
              _vm._v(_vm._s(_vm.employee.title)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "employee__country" }, [
              _vm._v(_vm._s(_vm.employee.country)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "employee__row" }, [
            _vm.employee.phone
              ? _c("p", { staticClass: "employee__text" }, [
                  _c(
                    "a",
                    {
                      staticClass: "employee__link",
                      attrs: { href: `tel:${_vm.employee.phone}` },
                    },
                    [_vm._v(_vm._s(_vm.employee.phone))]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.employee.email
              ? _c("div", { staticClass: "employee__text" }, [
                  _c("p", { staticClass: "employee__mail" }, [
                    _vm._v(_vm._s(_vm.employee.email)),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/scripts/vue/components/employee.vue